import { fetchBase, basicResponseHandler } from '../'

export default {
  fetchVersion() {
    return fetch('/version')
      .then(response => response.json())
      .then(({ data }) => data.version)
  },

  fetchSearchToken({ apiEndpoint, apiToken }) {
    return fetch(`${apiEndpoint}/users/me/searchToken`, {
      ...fetchBase({ apiToken }),
    }).then(basicResponseHandler)
  },
}
